export default {
  title: "Unbefugt",
  description: `<p>Zugang verweigert. Sie haben keine Berechtigung, diese Seite anzuzeigen.</p>
            <p>Wenn Sie glauben, dass dies ein Fehler ist, kontaktieren Sie bitte den Support.</p>`,
};
